import IRCAlertPostRequest from "./IRCAlertPostRequest";
import IRCAlertPreDelete from "./IRCAlertPreDelete";
import IModule from "../../interfaces/IModule";
import NotificationToast from "../NotificationToast";

type SweetAlertIcon = 'success' | 'error' | 'warning' | 'info' | 'question'

export default class RCAlerts {
  private module: IModule;

  constructor(
    module: IModule,
  ) {
    this.module = module;
  }

  public alert(
    icon: SweetAlertIcon,
    title: string,
    text?: string,
  ) {
    const message = text ? `${title}: ${text}` : title
    if (icon === 'error') {
      NotificationToast.error({ message })
    } else if (icon === 'success') {
      NotificationToast.success({ message })
    } else {
      NotificationToast.info({ message })
    }
  }

  public toast(
    icon: SweetAlertIcon,
    title: string,
    text?: string,
  ) {
    const message = text ? `${title}: ${text}` : title
    if (icon === 'error') {
      NotificationToast.error({ message })
    } else if (icon === 'success') {
      NotificationToast.success({ message })
    } else {
      NotificationToast.info({ message })
    }
  }

  public preCreate(input: IRCAlertPreDelete, text?: string) {
    if (window.confirm(text || 'Estas seguro de crear este registro?')) {
      input.onAccept()
    } else {
      input.onCancel()
    }
  }

  public preUpdate(input: IRCAlertPreDelete) {
    if (window.confirm(input.text || 'Estas seguro de modificar este registro?')) {
      input.onAccept()
    } else {
      input.onCancel()
    }
  }

  public preDelete(input: IRCAlertPreDelete) {
    if (window.confirm(input.text || 'Estas seguro de eliminar este registro?')) {
      input.onAccept()
    } else {
      input.onCancel()
    }
  }

  public created(input: IRCAlertPostRequest) {
    if (input.response.statusCode === input.successHttpCode) {
      NotificationToast.success({
        message: `${this.module.singularName} creado exitosamente`,
      })
      input.onAccept && input.onAccept()
    } else {
      NotificationToast.error({
        message: input.response.data?.message || 'No fue posible completar la operacion',
      })
      input.onCancel && input.onCancel()
    }
  }

  public update(input: IRCAlertPostRequest) {
    if (input.response.statusCode === input.successHttpCode) {
      NotificationToast.success({
        message: `${this.module.singularName} modificado exitosamente`,
      })
      input.onAccept && input.onAccept()
    } else {
      NotificationToast.error({
        message: input.response.data?.message || 'No fue posible completar la operacion',
      })
      input.onCancel && input.onCancel()
    }
  }

  public delete(input: IRCAlertPostRequest) {
    if (input.response.statusCode === input.successHttpCode) {
      NotificationToast.success({
        message: `${this.module.singularName} eliminado exitosamente`,
      })
      input.onAccept && input.onAccept()
    } else {
      NotificationToast.error({
        message: input.response.data?.message || 'No fue posible completar la operacion',
      })
      input.onCancel && input.onCancel()
    }
  }

  public custom(input: IRCAlertPreDelete) {
    if (window.confirm(input.text || 'Estas seguro de modificar este registro?')) {
      input.onAccept()
    } else {
      input.onCancel()
    }
  }
}
